import script from "./RepaymentOption.vue?vue&type=script&setup=true&lang=ts"
export * from "./RepaymentOption.vue?vue&type=script&setup=true&lang=ts"

import "@/styles/loan-options.scss?vue&type=style&index=0&id=3f197e42&scoped=true&lang=scss"

import exportComponent from "D:\\a\\1\\s\\src\\ApplicantPortal.Web\\clientapp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3f197e42"]])

export default __exports__